import { logError } from '@util/logError';
import { useEffect, useRef } from 'react';

const useLogWhenInView = (callback: () => void) => {
  const ref = useRef<HTMLDivElement>(null);
  // The observer is created once, so call the latest callback: otherwise a card
  // reused for a new search would still report the old search's attribution.
  const callbackRef = useRef(callback);
  useEffect(() => {
    callbackRef.current = callback;
  });
  useEffect(() => {
    let observer: IntersectionObserver;
    const element = ref.current;

    if (element) {
      observer = new IntersectionObserver(
        ([entry]) => {
          if (entry.isIntersecting) {
            try {
              callbackRef.current();
            } catch (e) {
              logError(e);
            }
            // Send event to Google Analytics
          }
        },
        {
          threshold: 0.1,
        }
      );

      observer.observe(element);
    }

    return () => {
      if (observer) {
        observer.disconnect();
      }
    };
  }, []);

  return ref;
};

export default useLogWhenInView;
